<template>
  <div class="bm-cell">
    <v-chip x-small dark :color="bandColor(band)" class="align-self-start">{{
      bandName(band)
    }}</v-chip>
    <span v-if="confidence" class="bm-tiny d-flex align-center">
      <v-icon v-if="estimated" x-small color="warning" class="mr-1">mdi-approximately-equal</v-icon>
      {{ confidence }}
    </span>
    <span v-else-if="note" class="bm-tiny">{{ note }}</span>
  </div>
</template>

<script>
import { bandColor, bandName } from "@/utils/budgetMonitor";

/** Band chip with the confidence line under it ("pasti 100 %" / "≈ estimasi 35 %"). */
export default {
  name: "budget-band-chip",
  props: {
    band: { type: String, default: "NO_BUDGET" },
    confidence: { type: String, default: "" },
    note: { type: String, default: "" },
  },
  computed: {
    estimated() {
      return this.confidence.startsWith("estimasi");
    },
  },
  methods: { bandColor, bandName },
};
</script>
